module.exports = __webpack_public_path__ + "static/media/logorentabilidad.ac512c89.svg";